import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { userType } from './constants/global-constants';
import { BlogDetailComponent } from './pages/blog-detail/blog-detail.component';
import { BlogListingComponent } from './pages/blog-listing/blog-listing.component';
import { ChatMainComponent } from './pages/chat-main/chat-main.component';
import { CreateBlogComponent } from './pages/create-blog/create-blog.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EditProfileMumComponent } from './pages/edit-profile-mum/edit-profile-mum.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { HomeComponent } from './pages/home/home.component';
import { NoteListingComponent } from './pages/note-listing/note-listing.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { RatingListingComponent } from './pages/rating-listing/rating-listing.component';
import { SearchListingComponent } from './pages/search-listing/search-listing.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'search-listing', component: SearchListingComponent },
  { path: 'chat', component: ChatMainComponent, canActivate:[AuthGuard], data:{role: userType.BOTH}},
  { path: 'blog-listing', component: BlogListingComponent },
  { path: 'blog-detail/:blogId', component: BlogDetailComponent },
  { path: 'ratings/:midwifeId', component: RatingListingComponent },
  { path: 'create-blog', component: CreateBlogComponent, canActivate:[AuthGuard], data:{ role: userType.MIDWIFE} },
  { path: 'edit-profile-midwife', component: EditProfileComponent, canActivate:[AuthGuard], data:{ role: userType.MIDWIFE} },
  { path: 'edit-profile-mum', component: EditProfileMumComponent, canActivate:[AuthGuard], data:{ role: userType.MUM} },
  { path: 'profile/:midwifeId', component: ProfileComponent},
  { path: 'dashboard', component: DashboardComponent, canActivate:[AuthGuard], data:{role: userType.BOTH}},
  { path: 'notes-list', component: NoteListingComponent, canActivate:[AuthGuard], data:{ role: userType.MIDWIFE}},
  { path: '', redirectTo: 'home', pathMatch:'full' },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
